// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HeartTwoToneSvg from "@ant-design/icons-svg/es/asn/HeartTwoTone";
import AntdIcon from '../components/AntdIcon';

var HeartTwoTone = function HeartTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HeartTwoToneSvg
  }));
};

HeartTwoTone.displayName = 'HeartTwoTone';
export default React.forwardRef(HeartTwoTone);